import { useEffect, useRef } from 'react';
import { useMount } from 'react-use';

function useInterval(
    callback: (realDelay: number) => void,
    delay: number | null,
    { includeLeading = false }: { includeLeading?: boolean } = {},
) {
    const savedCallback = useRef(callback);
    const lastTick = useRef<number>(0);

    useMount(() => {
        if (includeLeading && delay) {
            callback(0);
        }
    });

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            const now = Date.now();
            savedCallback.current(now - lastTick.current);
            lastTick.current = now;
        }
        if (delay !== null) {
            lastTick.current = Date.now();
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}

export default useInterval;
